import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import msgSliceReducer from './reciveMSG/reciveSlice';
import headerTitleSliceReducer from './headerTitle/headerTitleSlice';
import authReducer from './auth/authSlice';
import chequeInfoSlice from './cheque/chequeInfoSlice';
import videoSlice from './video/videoSlice';
import prevStateSlice from './handleBackBtn/handleBackBtnSlice';
import loansTabComponentsSlice from './loansTab/loansTabSlice';
import GuarantorInfo from '../pages/requestSteps/guarantors/guarantorInfo';
import guarantorInfoSlice from './guarantor/guarantorInfoSlice';
import unAtuthorizedHeaderTitleSliceReducer from './headerTitle/unAuthorizedSlice/unAtuthorizedHeaderTitleSlice';
import unAuthorizedStateLocalSlice from './unAuthorizedState/unAuthorizedStateSlice';
import themeSlice from './theme/themeSlice';
import notSetteledSlice from './notSetteledInstallments/notSettledSlice';
import subscriptionPlanSlice from './subscriptionPlan/subscriptionPlanSlice';
import calulationResultSlice from './loanCalculationResult/loanCalculationResultSlice';
import sheetHeaderSliceReducer from './sheetHeader/sheetHeaderSlice';
// Persist config
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'], // only 'auth' will be persisted
};
const rootReducer = combineReducers({
    // Add other reducers here
    auth: authReducer,
    msgSlice: msgSliceReducer,
    headerTitleSlice: headerTitleSliceReducer,
    chequeInfo: chequeInfoSlice,
    videoText: videoSlice,
    subscriptionPlan: subscriptionPlanSlice,
    loanCalculationResult: calulationResultSlice,
    prevAndNextState: prevStateSlice,
    loansTabComponents: loansTabComponentsSlice,
    guarantorInfo: guarantorInfoSlice,
    unauthorizedHeaderTitleSlice: unAtuthorizedHeaderTitleSliceReducer,
    unAutorizedState: unAuthorizedStateLocalSlice,
    theme: themeSlice,
    notSetteled: notSetteledSlice,
    sheetHeader: sheetHeaderSliceReducer,


    // reducer: {

    // },
});
// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

// Create the persistor
export const persistor = persistStore(store);
//To ensure proper TypeScript support, define RootState and AppDispatch types:
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
